import { jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { s as styles } from "../../../../chunks/Modal.module-BNu8pxzB.js";
const ModalFooter = ({ children, ...props }) => {
  return /* @__PURE__ */ jsx("footer", { className: clsx(styles.modalFooter, props.className), ...props, children });
};
export {
  ModalFooter
};
